import ScopesStore from "@stores/ScopesStore";
import { useGlobalState } from "./useGlobalState";

const useScopeStore = (): ScopesStore => {
  const [scopeScore] = useGlobalState("scopeStore");

  return scopeScore;
};

export default useScopeStore;
